<script lang="ts">
  import Spinner from './spinner.svelte'
  //

  import type { ButtonProps } from './button.types'
  import { button_recipe } from './button.svelte.recipe'

  //
  const {
    children,
    variant,
    colorPalette,
    size,
    class: classNative,
    ...props
  }: ButtonProps = $props()

  const recipeProps = { variant, colorPalette, size }

  const className = $derived(button_recipe({ ...recipeProps }) + ' ' + classNative)
</script>

<button class={className} {...props}>
  {#if !props.loading && !props.loadingText}
    {@render children()}
  {:else if props.loading && props.loadingText}
    <div>
      {@render loading()}
      <div>{props.loadingText}</div>
    </div>
  {:else}
    <div>
      {@render loading()}
    </div>
  {/if}
</button>

<!-- snippets -->
{#snippet loading()}
  <Spinner />
{/snippet}
